export const CREATIVE_TRAFFIC_METHOD = {
    OPTIMIZED: 'OPTIMIZED',
    EVEN: 'EVEN',
};

export default CREATIVE_TRAFFIC_METHOD;
